import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CoverageVisibilityService {
    public id = '';
    public isInputOutOfView$ = new BehaviorSubject<boolean>(false);

    private _showModal = new BehaviorSubject<boolean>(false);
    showModal$ = this._showModal.asObservable();

    show() { this._showModal.next(true); }
    hide() { this._showModal.next(false); }
} 